import { articlesSlice } from "./articlesSlice";
import * as actions from "./articlesActions";
import * as selectors from "./articlesSelectors";

export { actions };
export { selectors };
export default articlesSlice.reducer;
